/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCreateVehicleRequest, ApiVehicle, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of VehiclesController.
 */
export class VehiclesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /vehicles:prefill
     */
    public createPrefilledVehicle(apiCreateVehicleRequest: ApiCreateVehicleRequest | undefined): Promise<Result<ApiVehicle>> {
        return this.http.post<Result<ApiVehicle>, ApiCreateVehicleRequest | undefined>('/vehicles:prefill', apiCreateVehicleRequest);
    }

    /**
     * Calls POST /vehicles/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiVehicle>>> {
        return this.http.post<Result<LockedContextDto<ApiVehicle>>, undefined>(`/vehicles/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /vehicles/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiVehicle>> {
        return this.http.post<Result<ApiVehicle>, undefined>(`/vehicles/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /vehicles/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiVehicle[]>> {
        return this.http.post<Result<ApiVehicle[]>, string[]>('/vehicles/locks', ids);
    }

    /**
     * Calls POST /vehicles/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/vehicles/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /vehicles/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/vehicles/${primaryId}/locks`);
    }

    /**
     * Calls GET /vehicles/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiVehicle>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiVehicle>>(`/vehicles/${primaryId}`, query);
    }

    /**
     * Calls POST /vehicles
     */
    public add(dto: ApiVehicle): Promise<Result<ApiVehicle>> {
        return this.http.post<Result<ApiVehicle>, ApiVehicle>('/vehicles', dto);
    }

    /**
     * Calls PUT /vehicles/{primaryId}
     */
    public update(dto: ApiVehicle, primaryId: string): Promise<Result<ApiVehicle>> {
        return this.http.put<Result<ApiVehicle>, ApiVehicle>(`/vehicles/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /vehicles
     */
    public putRange(dtos: ApiVehicle[]): Promise<Result<ApiVehicle[]>> {
        return this.http.patch<Result<ApiVehicle[]>, ApiVehicle[]>('/vehicles', dtos);
    }

    /**
     * Calls DELETE /vehicles/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/vehicles/${primaryId}`);
    }

    /**
     * Calls POST /vehicles:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiVehicle>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiVehicle>>, ListRequestWithIds>('/vehicles:batch', listRequest, query);
    }

    /**
     * Calls POST /vehicles:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiVehicle>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiVehicle>>, ListRequest>('/vehicles:query', listRequest, query);
    }

    /**
     * Calls GET /vehicles:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiVehicle>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiVehicle>>>('/vehicles:query', query);
    }
}
